import { AfterViewInit, Component, Inject, Type } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthType } from '@core/enums/auth.enum';
import { AuthAbstractComponent } from '../abstracts/auth.abstract';
import { LoginComponent } from '../components/login/login.component';
import { AuthFacade } from '../auth.facade';

interface DialogData {
	component: Type<any>;
	authType?: AuthType;
	[key: string]: any;
}

@Component({
	selector: 'app-auth-dialog',
	templateUrl: './auth-dialog.component.html',
	styleUrls: ['./auth-dialog.component.scss'],
	providers: [AuthFacade],
})
export class AuthDialogComponent extends AuthAbstractComponent implements AfterViewInit {
	constructor(@Inject(MAT_DIALOG_DATA) private readonly dialogData: DialogData, private readonly dialogRef: MatDialogRef<AuthDialogComponent>) {
		super();
	}

	onClose(): void {
		this.dialogRef.close();
	}

	private setProperties(): void {
		if (this.dialogData) {
			const { component, authType, ...properties } = { ...this.dialogData };

			if (authType) {
				this.authType = authType;
			}

			this.loadComponent(component, properties);
		} else {
			this.loadComponent(LoginComponent);
		}
	}

	override ngAfterViewInit(): void {
		super.ngAfterViewInit();
		this.setProperties();
	}
}
